import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';

export const PreviewCard = ({ icon: Icon, title, children }) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'border.subtle',
      borderRadius: '8px',
      p: '16px',
      backgroundColor: 'white',
    }}
  >
    <Flex sx={{ alignItems: 'center', gap: '8px', mb: '12px' }}>
      <Box as={Icon} sx={{ width: '20px', height: '20px', color: 'purple.400' }} />
      <Text sx={{ fontSize: '14px', fontWeight: 600, color: 'text.dark' }}>{title}</Text>
    </Flex>
    {children}
  </Box>
);

PreviewCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
